import Splide from '@splidejs/splide';
( function( app ) {
  const VIMEO_ORIGIN = 'https://player.vimeo.com';

  const COMPONENT = {
    init: function() {
      $( '.featured-social-videos__slider' ).each( function( index, element ) {
        const slideCount = $( element ).find( '.splide__slide' ).length;
        const state = {
          card: null,
          iframe: null,
          popupOpen: false,
          offscreen: false,
        };

        const post = ( method, value ) => {
          if ( state.iframe?.contentWindow ) {
            state.iframe.contentWindow.postMessage( JSON.stringify( {method, value} ), VIMEO_ORIGIN );
          }
        };

        // the active video plays unless the user paused it, the popup is open, or it's offscreen
        const shouldPlay = () => state.card && !state.card.hasClass( 'is-paused' ) && !state.popupOpen && !state.offscreen;
        const sync = () => post( shouldPlay() ? 'play' : 'pause' );

        const activate = ( slideEl ) => {
          const card = $( slideEl ).find( '.featured-social-videos__card' );
          if ( state.card && state.card.is( card ) ) return;

          if ( state.card ) {
            state.card.removeClass( 'is-playing is-paused has-started' );
            state.card.find( '.featured-social-videos__player' ).empty();
          }

          const id = $( slideEl ).data( 'vimeo-id' );
          const hash = $( slideEl ).data( 'vimeo-hash' );
          const params = new URLSearchParams( {
            autoplay: 0,
            muted: 1,
            loop: 1,
            controls: 0,
            title: 0,
            byline: 0,
            portrait: 0,
            autopause: 0,
            dnt: 1,
            playsinline: 1,
          } );
          if ( hash ) params.set( 'h', hash );

          const iframe = $( '<iframe>', {
            'src': `${VIMEO_ORIGIN}/video/${id}?${params.toString()}`,
            'allow': 'autoplay; fullscreen; picture-in-picture',
            'tabindex': -1,
            'aria-hidden': true,
            'title': '',
          } );

          card.addClass( 'is-playing' );
          if ( !window.hasMotion ) {
            card.addClass( 'is-paused' );
          }
          card.find( '.featured-social-videos__toggle' ).attr( 'aria-label', window.hasMotion ? 'Pause video' : 'Play video' );
          card.find( '.featured-social-videos__player' ).append( iframe );

          state.card = card;
          state.iframe = iframe[0];
        };

        // Vimeo player events: start playback once ready, reveal the iframe once it's actually playing
        window.addEventListener( 'message', function( e ) {
          if ( e.origin !== VIMEO_ORIGIN || !state.iframe || e.source !== state.iframe.contentWindow ) return;

          let data = e.data;
          if ( typeof data === 'string' ) {
            try {
              data = JSON.parse( data );
            } catch ( err ) {
              return;
            }
          }

          if ( data.event === 'ready' ) {
            post( 'addEventListener', 'playing' );
            sync();
          } else if ( data.event === 'playing' ) {
            state.card.addClass( 'has-started' );
          }
        } );

        const GAP = 18;
        let slider = null;

        const mountSlider = () => {
          if ( slider ) return;
          $( element ).removeClass( 'is-static' );
          slider = new Splide( element, {
            type: 'loop',
            focus: 'center',
            autoWidth: true,
            gap: `${GAP}px`,
            arrows: false,
            pagination: slideCount > 1,
            drag: slideCount > 1,
            perMove: 1,
            speed: 800,
            classes: {
              pagination: 'splide__pagination featured-social-videos__pagination',
              page: 'splide__pagination__page featured-social-videos__page',
            },
          } );

          slider.on( 'mounted moved', function() {
            activate( slider.Components.Slides.getAt( slider.index ).slide );
          } );

          // clicking any video brings it to the center (the popup is opened by the global .js-init-video handler)
          slider.on( 'click', function( slide ) {
            slider.go( slide.isClone ? slide.slideIndex : slide.index );
          } );

          slider.mount();
        };

        // static row: no slider, the middle video plays
        const unmountSlider = () => {
          if ( slider ) {
            slider.destroy();
            slider = null;
          } else if ( $( element ).hasClass( 'is-static' ) ) {
            return;
          }
          $( element ).addClass( 'is-static' );
          const slides = $( element ).find( '.splide__slide' );
          activate( slides.get( Math.floor( ( slides.length - 1 ) / 2 ) ) );
        };

        // only slide when the videos don't all fit on screen — card widths come from the chosen ratio,
        // so this adapts to ratio, slide count and screen size (clones are ignored so the result is the same in both modes)
        const fitsWithoutSlider = () => {
          let total = GAP * ( slideCount - 1 );
          $( element ).find( '.splide__slide:not(.splide__slide--clone) .featured-social-videos__card' ).each( function() {
            total += this.getBoundingClientRect().width;
          } );
          return total <= element.clientWidth;
        };

        const update = () => fitsWithoutSlider() ? unmountSlider() : mountSlider();
        update();

        if ( 'ResizeObserver' in window ) {
          new ResizeObserver( update ).observe( element );
        } else {
          $( window ).on( 'resize', update );
        }

        // in the static row, clicking a video makes it the playing one
        $( element ).on( 'click', '.js-init-video', function() {
          if ( !slider ) {
            activate( $( this ).closest( '.splide__slide' ) );
          }
        } );

        $( element ).on( 'click', '.featured-social-videos__toggle', function( e ) {
          e.preventDefault();
          e.stopPropagation();
          const card = $( this ).closest( '.featured-social-videos__card' );
          if ( !card.is( state.card ) ) return;

          card.toggleClass( 'is-paused' );
          $( this ).attr( 'aria-label', card.hasClass( 'is-paused' ) ? 'Play video' : 'Pause video' );
          sync();
        } );

        $( document ).on( 'mfpOpen', function() {
          state.popupOpen = true;
          sync();
        } );
        $( document ).on( 'mfpClose', function() {
          state.popupOpen = false;
          sync();
        } );

        if ( 'IntersectionObserver' in window ) {
          new IntersectionObserver( function( entries ) {
            state.offscreen = !entries[0].isIntersecting;
            sync();
          } ).observe( element );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-social-videos', COMPONENT );
} )( app );
